export default {
  authTitle: 'Event registration',
  authSubtitle: 'Sign in to submit the form',
  votingAuthTitle: 'Voting',
  votingAuthSubtitle: 'Sign in to access the voting link',
  tabPhone: 'Phone',
  tabEmail: 'Email',
  tabWechat: 'WeChat',
  phonePlaceholder: '11-digit mobile number',
  codePlaceholder: 'SMS code',
  emailPlaceholder: 'Email address',
  passwordPlaceholder: 'Password',
  phoneRequired: 'Phone number is required',
  phoneInvalid: 'Invalid mainland mobile number',
  codeRequired: 'Verification code is required',
  emailRequired: 'Email is required',
  emailInvalid: 'Invalid email',
  passwordRequired: 'Password is required',
  login: 'Sign in',
  register: 'Sign up',
  loginSuccess: 'Signed in',
  registerLoginSuccess: 'Registered and signed in',
  codeSent: 'Code sent',
  wechatTip: 'Tap below to authorize in WeChat',
  wechatEnvTip: 'WeChat login works inside WeChat browser only',
  wechatLogging: 'Signing in with WeChat…',
  wechatLogin: 'WeChat sign in',
  wechatNotConfigured: 'WeChat login is not configured',
  noAccount: 'No account yet?',
  goRegister: 'Register with email',
  hasAccount: 'Already have an account?',
  goLogin: 'Sign in',
  nickname: 'Nickname',
  nicknamePlaceholder: 'Your nickname',
  email: 'Email',
  password: 'Password',
  passwordConfirm: 'Confirm password',
  nicknameRequired: 'Nickname is required',
  passwordConfirmRequired: 'Please confirm password',
  passwordMismatch: 'Passwords do not match',
  registerPendingTitle: 'Verification email sent',
  registerPendingDesc: 'A verification link was sent to {email}. Complete verification within {hours} hours.',
  registerPendingHint: 'After verification, return here and sign in with email and password.',
  registerFlowTip: 'Submit the form to receive a verification email. You can sign in only after verifying.',
  sendVerifyEmail: 'Send verification email',
  emailModeLogin: 'Sign in',
  emailModeRegister: 'Register',
  emailLoginTip: 'Use a verified email and password. Not verified yet? Switch to Register.',
  passwordConfirmPlaceholder: 'Confirm password',
  verifySuccessTitle: 'Email verified',
  verifyFailedTitle: 'Verification failed',
  verifyConflictTitle: 'Cannot verify',
  verifyMissingToken: 'Missing token. Open the link from your email.',
  verifyNetworkError: 'Network error. Please try again.',
  logout: 'Sign out'
}
